// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const resetPipDetails = () => ({
    type: actions.RESET_CLAIM_PIP_PIP_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/reset-pip-details.js